var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("img", { attrs: { src: require("../assets/logo.png"), alt: "logo" } }),
    _vm._v(" "),
    _c("table", { staticClass: "mt-4" }, [
      _c("tr", [
        _c("td", [
          _vm.greeting
            ? _c("span", [_vm._v(" " + _vm._s(_vm.greeting))])
            : _c("span", [_vm._v("zup")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "mt-2 btn",
        on: {
          click: function($event) {
            return _vm.getGreeting()
          }
        }
      },
      [_vm._v("Update Greeting")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }